// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-bar-chart-widget-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0,0.45);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-bar-chart-widget-container{
    width: 42vw;
    margin-top: 6vh;
    border-radius: 5px;
    background-color: white;
}
.new-bar-chart-widget-header-container{
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-bar-chart-widget-header-container h1{
    margin: 0px;
    color: white;
    font-size: 20px;
    font-weight: 600;
}
.new-bar-chart-widget-header-container .buttons-container{
    display: flex;
    align-items: center;
}
.new-bar-chart-widget-header-container .help-button{
    padding: 0;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    font-size: 15px;
    cursor: pointer;
    margin-left: 10px;
    color: rgba(155, 30, 30, 0.952);
}
.new-bar-chart-widget-header-container .close-editor-button{
    border: none;
    color: white;
    padding: 0;
    width: 30px;
    height: 30px;
    font-size: 18px;
    cursor: pointer;
    border-radius: 50%;
    margin-left: 10px;
    background-color: transparent;
}
.new-bar-chart-widget-header-container .close-editor-button:hover{
    background-color: rgba(102, 19, 19, 0.952);
}
.new-bar-chart-widget-body-container{
    height: 64vh;
    overflow-y: auto;
    padding: 10px 15px;
}
.new-bar-chart-widget-body-container::-webkit-scrollbar{
    width: 5px;
}
.new-bar-chart-widget-body-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.3);
}


.new-bar-chart-widget-time-window-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.new-bar-chart-widget-time-window-container .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.new-bar-chart-widget-time-window-container .header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.new-bar-chart-widget-time-window-container .header div{
    border-radius: 15px;
    background-color: rgb(231, 231, 231);
}
.new-bar-chart-widget-time-window-container .header button{
    border: none;
    cursor: pointer;
    padding: 6px 15px;
    border-radius: 15px;
    color: rgb(134, 134, 134);
    background-color: rgb(231, 231, 231);
}
.new-bar-chart-widget-time-window-container .header button.active{
    color: rgb(0, 128, 0);;
    background-color: white;
    border: 1px solid rgb(0, 128, 0);
}
.new-bar-chart-widget-time-window-container .body{
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding: 16px 12px;
    border-radius: 5px;
    border: 1px solid rgb(230, 230, 230);
}
.new-bar-chart-widget-time-window-container .body p{
    margin: 0px 16px;
}
.new-bar-chart-widget-time-window-container .inactive-time-window-mask.active{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.719);
}
.new-bar-chart-widget-time-window-container .body .time-window-selector-container{
    position: relative;
}
.new-bar-chart-widget-time-window-container .body .show-time-window-selector-button{
    padding: 5px 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid rgb(168, 168, 168);
    background-color: rgb(248, 248, 248);
    transition: background-color 0.25s ease;
}
.new-bar-chart-widget-time-window-container .body .show-time-window-selector-button:hover{
    background-color: rgb(236, 236, 236);
}
.new-bar-chart-widget-time-window-container .body .show-time-window-selector-button img{
    height: 16px;
    margin-right: 10px;
}


.new-bar-chart-widget-data-source-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.new-bar-chart-widget-data-source-container .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.new-bar-chart-widget-data-source-container .header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.new-bar-chart-widget-data-source-container .header div{
    border-radius: 15px;
    background-color: rgb(231, 231, 231);
}
.new-bar-chart-widget-data-source-container .header button{
    border: none;
    cursor: pointer;
    padding: 6px 15px;
    border-radius: 15px;
    color: rgb(134, 134, 134);
    background-color: rgb(231, 231, 231);
}
.new-bar-chart-widget-data-source-container .header button.active{
    color: rgb(0, 128, 0);;
    background-color: white;
    border: 1px solid rgb(0, 128, 0);
}
.new-bar-chart-widget-data-source-container .body .device-selection-container,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container{
    position: relative;
    margin: 20px 0px;
    margin-bottom: 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.new-bar-chart-widget-data-source-container .body .device-selection-container:focus-within,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.953);
}
.new-bar-chart-widget-data-source-container .body .device-selection-container p,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container p{
    margin: 0px;
    font-size: 12px;
    cursor: pointer;
    color: rgb(88, 88, 88);
}
.new-bar-chart-widget-data-source-container .body .device-selection-container span,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container span{
    color: red;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container{
    display: flex;
    justify-content: space-between;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container input,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input{
    flex: 1 1;
    border: none;
    outline: none;
    box-sizing: border-box;
    background-color: transparent;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container input.inactive,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.inactive{
    color: gray;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container input.active
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.active{
    color: rgb(30, 30, 30);
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container p
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container p{
    margin-right: 10px;
    cursor: pointer;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 24vh;
    overflow-y: auto;
    width: 100%;
    display: none;
    margin-top: 2px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser.active,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser.active{
    display: block;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser div,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div{
    padding: 10px 12px;
    cursor: pointer;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(216, 216, 216);
    transition: background-color 0.25s ease;
}
.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser div:hover,
.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div:hover{
    background-color: rgb(236, 236, 236);
}
.new-bar-chart-widget-data-source-container .body .label{
    margin: 0px;
    margin-top: 2px;
    margin-left: 12px;
    color: red;
    font-size: 12px;
}

/*Series section*/
.new-bar-chart-widget-series-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.new-bar-chart-widget-series-container h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.new-bar-chart-widget-series-container .body table{
    width: 100%;
    margin: 10px 0px;
    border-radius: 4px;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid rgb(192, 192, 192);
}
.new-bar-chart-widget-series-container .body table th{
    padding: 8px 12px;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    color: rgb(104, 104, 104);
    border-bottom: 1px solid rgb(192, 192, 192);
}
.new-bar-chart-widget-series-container .body table td{
    padding: 4px 12px;
    padding-top: 10px;
}
.new-bar-chart-widget-series-container .body table .series-key-container{
    position: relative;
    box-sizing: border-box;
}
.new-bar-chart-widget-series-container .body table .series-key-container input{
    width: calc(100% - 5px);
    display: block;
    margin: 0px;
    padding: 4px 5px;
    border: none;
    outline: none;
    color: gray;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(192, 192, 192);
}
.new-bar-chart-widget-series-container .body table .series-key-container input:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.953);
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry{
    margin: 5px 0px;
    border-bottom: 1px solid rgb(192, 192, 192);
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div{
    margin: 0px 2px;
    margin-bottom: 2px;
    padding: 2px 8px;
    border-radius: 16px;
    display: inline-block;
    text-wrap: nowrap;
    font-size: 14px;
    cursor: default;
    background-color: lightgray;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon-container{
    margin: 0px;
    padding: 0px;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon{
    display: flex;
    transform: rotate(220deg);
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry-container{
    display: inline-block;
    margin: 0px;
    padding: 0px;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry{
    display: flex;
    max-width: 3.2vw;
    padding: 0px;
    margin: 0px 10px;
    margin-bottom: 2px;
    font-size: 12px;
    text-wrap: nowrap;
    overflow: hidden;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .remove-key{
    font-size: 14px;
    cursor: pointer;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 22vh;
    overflow-y: auto;
    max-width: 120%;
    min-width: 100%;
    left: 15px;
    display: none;
    margin-top: 0px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser.active{
    display: block;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar{
    width: 4px;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.3);
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser div{
    padding: 10px 12px;
    cursor: pointer;
    white-space: nowrap;
    box-sizing: border-box;
    font-size: 14px;
    overflow-x: hidden;
    border-bottom: 1px solid rgb(216, 216, 216);
    transition: background-color 0.25s ease;
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser div:hover{
    background-color: rgb(236, 236, 236);
}
.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser div span{
    margin-right: 5px;
    display: inline-block;
    transform: rotate(-145deg);
}
.new-bar-chart-widget-series-container .body table .series-label-container{
    box-sizing: border-box;
}
.new-bar-chart-widget-series-container .body table .series-label-container input{
    width: 100%;
    padding: 4px 10px;
    outline: none;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-bar-chart-widget-series-container .body table .series-max-value-container,
.new-bar-chart-widget-series-container .body table .series-color-container,
.new-bar-chart-widget-series-container .body table .series-units-container,
.new-bar-chart-widget-series-container .body table .series-decimals-container{
    position: relative;
    box-sizing: border-box;
}
.new-bar-chart-widget-series-container .body table .series-max-value-container input{
    width: 100%;
    padding: 4px 10px;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-bar-chart-widget-series-container .body table .series-color-container input{
    width: 25px;
    height: 25px;
    margin: 0px;
    padding: 0px;
    border: none;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;
    background-color: transparent;
}
.new-bar-chart-widget-series-container .body table  .series-units-container input{
    width: 100%;
    padding: 4px 8px;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
    color: gray;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-bar-chart-widget-series-container .body table  .series-units-container .units-key-entry{
    padding: 4px 8px;
    padding-left: 10px;
    font-size: 14px;
    cursor: default;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgb(216, 216, 216);
}
.new-bar-chart-widget-series-container .body table  .series-units-container .units-key-entry .remove-units{
    cursor: pointer;
    font-size: 13px;
    color: rgb(104, 104, 104);
}
.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 22vh;
    overflow-y: auto;
    width: 200px;
    left: 20px;
    display: none;
    margin-top: 0px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser.active{
    display: block;
}
.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser div{
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    cursor: pointer;
    white-space: nowrap;
    box-sizing: border-box;
    font-size: 13px;
    overflow-x: hidden;
    transition: background-color 0.25s ease;
}
.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser div:hover{
    background-color: rgb(236, 236, 236);
}
.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar{
    width: 4px;
}
.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.3);
}
.new-bar-chart-widget-series-container .body table .series-decimals-container input{
    width: 100%;
    padding: 4px 2px;
    padding-left: 8px;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-bar-chart-widget-series-container .body table .series-delete-container button{
    border: none;
    cursor: pointer;
    background-color: transparent;
}
.new-bar-chart-widget-series-container .body table .series-delete-container button img{
    height: 20px;
}
.new-bar-chart-widget-series-container .body table .empty-series-container h3{
    margin: 20px 0px;
    margin-bottom: 6px;
    text-align: center;
    font-weight: 400;
    color: rgb(128, 128, 128);
}
.new-bar-chart-widget-series-container .body table .empty-series-container p{
    margin: 0px;
    color: red;
    font-size: 12px;
    text-align: center;
    margin-bottom: 20px;
}
.new-bar-chart-widget-series-container .body .add-series-button{
    margin-top: 10px;
    padding: 8px 12px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    color: rgba(155, 30, 30, 0.952);
    background-color: transparent;
    border: 1px solid rgb(212, 212, 212);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transition: background-color 0.25s ease;
}
.new-bar-chart-widget-series-container .body .add-series-button:hover{
    background-color: rgb(246, 246, 246);
}
.new-bar-chart-widget-series-container .empty-data-source-container h3{
    margin: 20px 0px;
    margin-bottom: 6px;
    text-align: center;
    font-weight: 400;
    color: rgb(128, 128, 128);
}
.new-bar-chart-widget-series-container .empty-data-source-container p{
    margin: 0px;
    color: red;
    font-size: 12px;
    text-align: center;
    margin-bottom: 20px;
}
/*End of series section*/

/*Appearance section*/
.new-bar-chart-widget-appearance-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.new-bar-chart-widget-appearance-container h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
    cursor: default;
}
.new-bar-chart-widget-appearance-container .title-container{
    display: flex;
    align-items: center;
}
.new-bar-chart-widget-appearance-container .body .title-entry-container{
    position: relative;
    width: 50%;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.new-bar-chart-widget-appearance-container .body .title-entry-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.953);
}
.new-bar-chart-widget-appearance-container .body .title-entry-container p{
    margin: 0px;
    font-size: 12px;
}
.new-bar-chart-widget-appearance-container .body .title-entry-container input{
    width: 100%;
    border: none;
    outline: none;
    box-sizing: border-box;
    background-color: transparent;
}
.new-bar-chart-widget-appearance-container .body .show-title-container{
    padding-left: 25px;
    display: flex;
    align-items: center;
}
.new-bar-chart-widget-appearance-container .body .show-title-container p{
    margin: 0px;
}
.new-bar-chart-widget-appearance-container .title-color-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.new-bar-chart-widget-appearance-container .title-color-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.new-bar-chart-widget-appearance-container .title-color-container p{
    margin: 0px;
    font-size: 12px;
    color: rgb(88, 88, 88);
}
.new-bar-chart-widget-appearance-container .title-color-container div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.new-bar-chart-widget-appearance-container .title-color-container div p{
    font-size: 14px;
    color: rgb(26, 26, 26);
}
.new-bar-chart-widget-appearance-container .title-color-container div input{
    width: 25px;
    height: 25px;
    margin: 0px;
    padding: 0px;
    border: none;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;
}
.new-bar-chart-widget-appearance-container .border-radius-container,
.new-bar-chart-widget-appearance-container .mobile-height-container,
.new-bar-chart-widget-appearance-container .maximum-value-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.new-bar-chart-widget-appearance-container .border-radius-container:focus-within,
.new-bar-chart-widget-appearance-container .mobile-height-container:focus-within,
.new-bar-chart-widget-appearance-container .maximum-value-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.new-bar-chart-widget-appearance-container .border-radius-container p,
.new-bar-chart-widget-appearance-container .mobile-height-container p,
.new-bar-chart-widget-appearance-container .maximum-value-container p{
    margin: 0px;
    font-size: 12px;
    color: rgb(88, 88, 88);
}
.new-bar-chart-widget-appearance-container .border-radius-container div,
.new-bar-chart-widget-appearance-container .mobile-height-container div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.new-bar-chart-widget-appearance-container .border-radius-container div p,
.new-bar-chart-widget-appearance-container .mobile-height-container div p{
    font-size: 14px;
    color: rgb(26, 26, 26);
}
.new-bar-chart-widget-appearance-container .border-radius-container div input,
.new-bar-chart-widget-appearance-container .mobile-height-container div input{
    width: 25%;
    cursor: pointer;
}
.new-bar-chart-widget-appearance-container .maximum-value-container input{
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
}
/*End of appearance section*/
.new-bar-chart-widget-control-buttons-container{
    padding: 16px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 0px 8px rgba(199, 199, 199, 0.15);
}
.new-bar-chart-widget-control-buttons-container button{
    font-weight: 600;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.new-bar-chart-widget-control-buttons-container .cancel-button{
    padding: 10px 20px;
    color: rgba(155, 30, 30, 0.952);
    background-color: rgb(240, 240, 240);
}
.new-bar-chart-widget-control-buttons-container .add-button{
    padding: 10px 25px;
    opacity: 0.7;
    font-weight: 500;
    cursor: not-allowed;
    color: rgb(196, 196, 196);
    background-color: rgb(240, 240, 240);
}
.new-bar-chart-widget-control-buttons-container .add-button.active{
    opacity: 1;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
}
.new-bar-chart-widget-control-buttons-container .add-button.active:hover{
    background-color: rgba(170, 46, 46, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/Charts/NewBarChartWidget.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,4CAA4C;AAChD;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,oCAAoC;IACpC,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;AACpC;AACA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;;IAEI,iDAAiD;AACrD;AACA;;IAEI,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,UAAU;AACd;AACA;;IAEI,aAAa;IACb,8BAA8B;AAClC;AACA;;IAEI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,sBAAsB;AAC1B;AACA;;IAEI,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,2CAA2C;IAC3C,uCAAuC;AAC3C;AACA;;IAEI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;AAC/C;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,eAAe;IACf,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,UAAU;IACV,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,2CAA2C;IAC3C,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;;;;IAII,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,4DAA4D;IAC5D,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA,wBAAwB;;AAExB,qBAAqB;AACrB;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;AACA;;;IAGI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;;;IAGI,iDAAiD;AACrD;AACA;;;IAGI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;;IAEI,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,UAAU;IACV,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;AACA,4BAA4B;AAC5B;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,iDAAiD;AACrD;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C","sourcesContent":[".new-bar-chart-widget-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0,0.45);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-bar-chart-widget-container{\r\n    width: 42vw;\r\n    margin-top: 6vh;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n}\r\n.new-bar-chart-widget-header-container{\r\n    padding: 12px 20px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-bar-chart-widget-header-container h1{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n.new-bar-chart-widget-header-container .buttons-container{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.new-bar-chart-widget-header-container .help-button{\r\n    padding: 0;\r\n    width: 24px;\r\n    height: 24px;\r\n    border: none;\r\n    border-radius: 50%;\r\n    font-size: 15px;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n    color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-bar-chart-widget-header-container .close-editor-button{\r\n    border: none;\r\n    color: white;\r\n    padding: 0;\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    margin-left: 10px;\r\n    background-color: transparent;\r\n}\r\n.new-bar-chart-widget-header-container .close-editor-button:hover{\r\n    background-color: rgba(102, 19, 19, 0.952);\r\n}\r\n.new-bar-chart-widget-body-container{\r\n    height: 64vh;\r\n    overflow-y: auto;\r\n    padding: 10px 15px;\r\n}\r\n.new-bar-chart-widget-body-container::-webkit-scrollbar{\r\n    width: 5px;\r\n}\r\n.new-bar-chart-widget-body-container::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n\r\n.new-bar-chart-widget-time-window-container{\r\n    padding: 25px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\r\n}\r\n.new-bar-chart-widget-time-window-container .header{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.new-bar-chart-widget-time-window-container .header h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n.new-bar-chart-widget-time-window-container .header div{\r\n    border-radius: 15px;\r\n    background-color: rgb(231, 231, 231);\r\n}\r\n.new-bar-chart-widget-time-window-container .header button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 6px 15px;\r\n    border-radius: 15px;\r\n    color: rgb(134, 134, 134);\r\n    background-color: rgb(231, 231, 231);\r\n}\r\n.new-bar-chart-widget-time-window-container .header button.active{\r\n    color: rgb(0, 128, 0);;\r\n    background-color: white;\r\n    border: 1px solid rgb(0, 128, 0);\r\n}\r\n.new-bar-chart-widget-time-window-container .body{\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: 20px;\r\n    padding: 16px 12px;\r\n    border-radius: 5px;\r\n    border: 1px solid rgb(230, 230, 230);\r\n}\r\n.new-bar-chart-widget-time-window-container .body p{\r\n    margin: 0px 16px;\r\n}\r\n.new-bar-chart-widget-time-window-container .inactive-time-window-mask.active{\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    background-color: rgba(255, 255, 255, 0.719);\r\n}\r\n.new-bar-chart-widget-time-window-container .body .time-window-selector-container{\r\n    position: relative;\r\n}\r\n.new-bar-chart-widget-time-window-container .body .show-time-window-selector-button{\r\n    padding: 5px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    border: 1px solid rgb(168, 168, 168);\r\n    background-color: rgb(248, 248, 248);\r\n    transition: background-color 0.25s ease;\r\n}\r\n.new-bar-chart-widget-time-window-container .body .show-time-window-selector-button:hover{\r\n    background-color: rgb(236, 236, 236);\r\n}\r\n.new-bar-chart-widget-time-window-container .body .show-time-window-selector-button img{\r\n    height: 16px;\r\n    margin-right: 10px;\r\n}\r\n\r\n\r\n.new-bar-chart-widget-data-source-container{\r\n    padding: 25px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\r\n}\r\n.new-bar-chart-widget-data-source-container .header{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.new-bar-chart-widget-data-source-container .header h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n.new-bar-chart-widget-data-source-container .header div{\r\n    border-radius: 15px;\r\n    background-color: rgb(231, 231, 231);\r\n}\r\n.new-bar-chart-widget-data-source-container .header button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 6px 15px;\r\n    border-radius: 15px;\r\n    color: rgb(134, 134, 134);\r\n    background-color: rgb(231, 231, 231);\r\n}\r\n.new-bar-chart-widget-data-source-container .header button.active{\r\n    color: rgb(0, 128, 0);;\r\n    background-color: white;\r\n    border: 1px solid rgb(0, 128, 0);\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container{\r\n    position: relative;\r\n    margin: 20px 0px;\r\n    margin-bottom: 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(222, 229, 233, 0.6);\r\n    border-bottom: 1px solid rgb(128, 128, 128);\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container:focus-within,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.953);\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container p,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    color: rgb(88, 88, 88);\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container span,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container span{\r\n    color: red;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container input,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input{\r\n    flex: 1;\r\n    border: none;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container input.inactive,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.inactive{\r\n    color: gray;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container input.active\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.active{\r\n    color: rgb(30, 30, 30);\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .entry-container p\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container p{\r\n    margin-right: 10px;\r\n    cursor: pointer;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser{\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 100%;\r\n    max-height: 24vh;\r\n    overflow-y: auto;\r\n    width: 100%;\r\n    display: none;\r\n    margin-top: 2px;\r\n    box-sizing: border-box;\r\n    transform: translateX(-10px);\r\n    background-color: white;\r\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\r\n    border-radius: 0px 0px 4px 4px;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser.active,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser.active{\r\n    display: block;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser div,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div{\r\n    padding: 10px 12px;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid rgb(216, 216, 216);\r\n    transition: background-color 0.25s ease;\r\n}\r\n.new-bar-chart-widget-data-source-container .body .device-selection-container .devices-browser div:hover,\r\n.new-bar-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div:hover{\r\n    background-color: rgb(236, 236, 236);\r\n}\r\n.new-bar-chart-widget-data-source-container .body .label{\r\n    margin: 0px;\r\n    margin-top: 2px;\r\n    margin-left: 12px;\r\n    color: red;\r\n    font-size: 12px;\r\n}\r\n\r\n/*Series section*/\r\n.new-bar-chart-widget-series-container{\r\n    padding: 25px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\r\n}\r\n.new-bar-chart-widget-series-container h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n.new-bar-chart-widget-series-container .body table{\r\n    width: 100%;\r\n    margin: 10px 0px;\r\n    border-radius: 4px;\r\n    table-layout: fixed;\r\n    border-collapse: collapse;\r\n    border: 1px solid rgb(192, 192, 192);\r\n}\r\n.new-bar-chart-widget-series-container .body table th{\r\n    padding: 8px 12px;\r\n    text-align: left;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: rgb(104, 104, 104);\r\n    border-bottom: 1px solid rgb(192, 192, 192);\r\n}\r\n.new-bar-chart-widget-series-container .body table td{\r\n    padding: 4px 12px;\r\n    padding-top: 10px;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container{\r\n    position: relative;\r\n    box-sizing: border-box;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container input{\r\n    width: calc(100% - 5px);\r\n    display: block;\r\n    margin: 0px;\r\n    padding: 4px 5px;\r\n    border: none;\r\n    outline: none;\r\n    color: gray;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid rgb(192, 192, 192);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container input:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.953);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry{\r\n    margin: 5px 0px;\r\n    border-bottom: 1px solid rgb(192, 192, 192);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div{\r\n    margin: 0px 2px;\r\n    margin-bottom: 2px;\r\n    padding: 2px 8px;\r\n    border-radius: 16px;\r\n    display: inline-block;\r\n    text-wrap: nowrap;\r\n    font-size: 14px;\r\n    cursor: default;\r\n    background-color: lightgray;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon-container{\r\n    margin: 0px;\r\n    padding: 0px;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon{\r\n    display: flex;\r\n    transform: rotate(220deg);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry-container{\r\n    display: inline-block;\r\n    margin: 0px;\r\n    padding: 0px;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry{\r\n    display: flex;\r\n    max-width: 3.2vw;\r\n    padding: 0px;\r\n    margin: 0px 10px;\r\n    margin-bottom: 2px;\r\n    font-size: 12px;\r\n    text-wrap: nowrap;\r\n    overflow: hidden;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-key-entry div .remove-key{\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser{\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 100%;\r\n    max-height: 22vh;\r\n    overflow-y: auto;\r\n    max-width: 120%;\r\n    min-width: 100%;\r\n    left: 15px;\r\n    display: none;\r\n    margin-top: 0px;\r\n    box-sizing: border-box;\r\n    transform: translateX(-10px);\r\n    background-color: white;\r\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\r\n    border-radius: 0px 0px 4px 4px;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser.active{\r\n    display: block;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar-thumb{\r\n    border-radius: 10px;\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser div{\r\n    padding: 10px 12px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    box-sizing: border-box;\r\n    font-size: 14px;\r\n    overflow-x: hidden;\r\n    border-bottom: 1px solid rgb(216, 216, 216);\r\n    transition: background-color 0.25s ease;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser div:hover{\r\n    background-color: rgb(236, 236, 236);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-key-container .series-keys-browser div span{\r\n    margin-right: 5px;\r\n    display: inline-block;\r\n    transform: rotate(-145deg);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-label-container{\r\n    box-sizing: border-box;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-label-container input{\r\n    width: 100%;\r\n    padding: 4px 10px;\r\n    outline: none;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n    border: 1px solid rgb(216, 216, 216);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-max-value-container,\r\n.new-bar-chart-widget-series-container .body table .series-color-container,\r\n.new-bar-chart-widget-series-container .body table .series-units-container,\r\n.new-bar-chart-widget-series-container .body table .series-decimals-container{\r\n    position: relative;\r\n    box-sizing: border-box;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-max-value-container input{\r\n    width: 100%;\r\n    padding: 4px 10px;\r\n    border-radius: 4px;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n    border: 1px solid rgb(216, 216, 216);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-color-container input{\r\n    width: 25px;\r\n    height: 25px;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    border: none;\r\n    outline: none;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container input{\r\n    width: 100%;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n    color: gray;\r\n    border: 1px solid rgb(216, 216, 216);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .units-key-entry{\r\n    padding: 4px 8px;\r\n    padding-left: 10px;\r\n    font-size: 14px;\r\n    cursor: default;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border: 1px solid rgb(216, 216, 216);\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .units-key-entry .remove-units{\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    color: rgb(104, 104, 104);\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser{\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 100%;\r\n    max-height: 22vh;\r\n    overflow-y: auto;\r\n    width: 200px;\r\n    left: 20px;\r\n    display: none;\r\n    margin-top: 0px;\r\n    box-sizing: border-box;\r\n    transform: translateX(-10px);\r\n    background-color: white;\r\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\r\n    border-radius: 0px 0px 4px 4px;\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser.active{\r\n    display: block;\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser div{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 10px 12px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    box-sizing: border-box;\r\n    font-size: 13px;\r\n    overflow-x: hidden;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser div:hover{\r\n    background-color: rgb(236, 236, 236);\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.new-bar-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar-thumb{\r\n    border-radius: 10px;\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-decimals-container input{\r\n    width: 100%;\r\n    padding: 4px 2px;\r\n    padding-left: 8px;\r\n    border-radius: 4px;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n    border: 1px solid rgb(216, 216, 216);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-delete-container button{\r\n    border: none;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n}\r\n.new-bar-chart-widget-series-container .body table .series-delete-container button img{\r\n    height: 20px;\r\n}\r\n.new-bar-chart-widget-series-container .body table .empty-series-container h3{\r\n    margin: 20px 0px;\r\n    margin-bottom: 6px;\r\n    text-align: center;\r\n    font-weight: 400;\r\n    color: rgb(128, 128, 128);\r\n}\r\n.new-bar-chart-widget-series-container .body table .empty-series-container p{\r\n    margin: 0px;\r\n    color: red;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n.new-bar-chart-widget-series-container .body .add-series-button{\r\n    margin-top: 10px;\r\n    padding: 8px 12px;\r\n    font-weight: 600;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    background-color: transparent;\r\n    border: 1px solid rgb(212, 212, 212);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    transition: background-color 0.25s ease;\r\n}\r\n.new-bar-chart-widget-series-container .body .add-series-button:hover{\r\n    background-color: rgb(246, 246, 246);\r\n}\r\n.new-bar-chart-widget-series-container .empty-data-source-container h3{\r\n    margin: 20px 0px;\r\n    margin-bottom: 6px;\r\n    text-align: center;\r\n    font-weight: 400;\r\n    color: rgb(128, 128, 128);\r\n}\r\n.new-bar-chart-widget-series-container .empty-data-source-container p{\r\n    margin: 0px;\r\n    color: red;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n/*End of series section*/\r\n\r\n/*Appearance section*/\r\n.new-bar-chart-widget-appearance-container{\r\n    padding: 25px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\r\n}\r\n.new-bar-chart-widget-appearance-container h2{\r\n    margin: 0px;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    cursor: default;\r\n}\r\n.new-bar-chart-widget-appearance-container .title-container{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.new-bar-chart-widget-appearance-container .body .title-entry-container{\r\n    position: relative;\r\n    width: 50%;\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(222, 229, 233, 0.6);\r\n    border-bottom: 1px solid rgb(128, 128, 128);\r\n}\r\n.new-bar-chart-widget-appearance-container .body .title-entry-container:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.953);\r\n}\r\n.new-bar-chart-widget-appearance-container .body .title-entry-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n}\r\n.new-bar-chart-widget-appearance-container .body .title-entry-container input{\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.new-bar-chart-widget-appearance-container .body .show-title-container{\r\n    padding-left: 25px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.new-bar-chart-widget-appearance-container .body .show-title-container p{\r\n    margin: 0px;\r\n}\r\n.new-bar-chart-widget-appearance-container .title-color-container{\r\n    position: relative;\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(222, 229, 233, 0.6);\r\n    border-bottom: 1px solid rgb(128, 128, 128);\r\n}\r\n.new-bar-chart-widget-appearance-container .title-color-container:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.new-bar-chart-widget-appearance-container .title-color-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    color: rgb(88, 88, 88);\r\n}\r\n.new-bar-chart-widget-appearance-container .title-color-container div{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.new-bar-chart-widget-appearance-container .title-color-container div p{\r\n    font-size: 14px;\r\n    color: rgb(26, 26, 26);\r\n}\r\n.new-bar-chart-widget-appearance-container .title-color-container div input{\r\n    width: 25px;\r\n    height: 25px;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    border: none;\r\n    outline: none;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n}\r\n.new-bar-chart-widget-appearance-container .border-radius-container,\r\n.new-bar-chart-widget-appearance-container .mobile-height-container,\r\n.new-bar-chart-widget-appearance-container .maximum-value-container{\r\n    position: relative;\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(222, 229, 233, 0.6);\r\n    border-bottom: 1px solid rgb(128, 128, 128);\r\n}\r\n.new-bar-chart-widget-appearance-container .border-radius-container:focus-within,\r\n.new-bar-chart-widget-appearance-container .mobile-height-container:focus-within,\r\n.new-bar-chart-widget-appearance-container .maximum-value-container:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.new-bar-chart-widget-appearance-container .border-radius-container p,\r\n.new-bar-chart-widget-appearance-container .mobile-height-container p,\r\n.new-bar-chart-widget-appearance-container .maximum-value-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    color: rgb(88, 88, 88);\r\n}\r\n.new-bar-chart-widget-appearance-container .border-radius-container div,\r\n.new-bar-chart-widget-appearance-container .mobile-height-container div{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.new-bar-chart-widget-appearance-container .border-radius-container div p,\r\n.new-bar-chart-widget-appearance-container .mobile-height-container div p{\r\n    font-size: 14px;\r\n    color: rgb(26, 26, 26);\r\n}\r\n.new-bar-chart-widget-appearance-container .border-radius-container div input,\r\n.new-bar-chart-widget-appearance-container .mobile-height-container div input{\r\n    width: 25%;\r\n    cursor: pointer;\r\n}\r\n.new-bar-chart-widget-appearance-container .maximum-value-container input{\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    background-color: transparent;\r\n}\r\n/*End of appearance section*/\r\n.new-bar-chart-widget-control-buttons-container{\r\n    padding: 16px;\r\n    padding-top: 20px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    box-shadow: 0px 0px 8px rgba(199, 199, 199, 0.15);\r\n}\r\n.new-bar-chart-widget-control-buttons-container button{\r\n    font-weight: 600;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n.new-bar-chart-widget-control-buttons-container .cancel-button{\r\n    padding: 10px 20px;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    background-color: rgb(240, 240, 240);\r\n}\r\n.new-bar-chart-widget-control-buttons-container .add-button{\r\n    padding: 10px 25px;\r\n    opacity: 0.7;\r\n    font-weight: 500;\r\n    cursor: not-allowed;\r\n    color: rgb(196, 196, 196);\r\n    background-color: rgb(240, 240, 240);\r\n}\r\n.new-bar-chart-widget-control-buttons-container .add-button.active{\r\n    opacity: 1;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.new-bar-chart-widget-control-buttons-container .add-button.active:hover{\r\n    background-color: rgba(170, 46, 46, 0.952);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
